import React, { useEffect, useState } from 'react'
import { Skeleton, Row, Col } from 'antd-v4'
import { AverageCart } from '../SalesSummary/V2/AverageCart'
import { NumberOfSales } from '../SalesSummary/V2/NumberOfSales'

interface Props {
  companyId: number
  locationIds: number[]
  startDate: string
  endDate: string
}

interface ReportFilters {
  startDate: string
  endDate: string
  companyId: number
  locationIds: number[]
}

export const SalesTrendsCards: React.FC<Props> = ({
  companyId,
  locationIds,
  startDate,
  endDate,
}: Props) => {
  const [reportFilters, setReportFilters] = useState<ReportFilters>()

  useEffect(() => {
    setReportFilters({
      companyId,
      locationIds,
      startDate,
      endDate,
    })
  }, [])

  if (!reportFilters) {
    return <Skeleton active />
  }

  return (
    <Row style={{ marginRight: '-1rem', marginBottom: '60px' }}>
      <Col xl={12} lg={24} md={24} sm={24} xs={24} className='d-flex'>
        <NumberOfSales {...reportFilters} />
      </Col>
      <Col xl={12} lg={24} md={24} sm={24} xs={24} className='d-flex'>
        <AverageCart {...reportFilters} />
      </Col>
    </Row>
  )
}
